// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__G53zA","col":"CardReaderDesc_col__3miqA","label":"CardReaderDesc_label__1OWlm"};